import { ExternalLink, Link2 } from "lucide-react";

import { getSafeLinkHref } from "@kushya/shared";

import type { QuestionRendererProps } from "../types";

export const LinkQuestion = ({
  question,
  mode,
}: QuestionRendererProps<null>) => {
  if (question.type !== "link") {
    return null;
  }

  const safeHref = getSafeLinkHref(question.url);
  const label =
    question.linkText?.trim() || question.title?.trim() || question.url;
  const openInNewTab = question.openInNewTab ?? true;
  const target = openInNewTab ? "_blank" : "_self";
  const rel = openInNewTab ? "noopener noreferrer" : undefined;
  const hint =
    mode === "preview"
      ? openInNewTab
        ? "Opens in a new tab"
        : "Opens in this tab"
      : undefined;

  if (!safeHref) {
    return (
      <div className="flex items-center gap-2 rounded-md border border-dashed border-border/70 bg-muted/20 px-3 py-2 text-sm text-muted-foreground">
        <Link2 className="size-4 shrink-0" />
        <span>{label}</span>
        <span className="text-xs text-muted-foreground/70">(Invalid URL)</span>
      </div>
    );
  }

  return (
    <div className="space-y-1.5">
      <a
        href={safeHref}
        target={target}
        rel={rel}
        className="inline-flex items-center gap-2 rounded-md border border-border/70 bg-background px-3 py-2 text-sm font-medium text-primary underline-offset-4 hover:underline"
      >
        <Link2 className="size-4 shrink-0" />
        <span>{label}</span>
        {openInNewTab ? <ExternalLink className="size-3.5 shrink-0" /> : null}
      </a>
      {hint ? <p className="text-xs text-muted-foreground">{hint}</p> : null}
    </div>
  );
};
